import React from "react";
import useCallCenterT from "../../hooks/useCallCenterT";
import CallCenterModal from "./listing/CallCenterModal";
import PaymentProofPanel from "./PaymentProofPanel";

const PaymentProofModal = ({ open, ticketId, onClose, onSaved }) => {
  const t = useCallCenterT();

  return (
    <CallCenterModal
      open={open && Boolean(ticketId)}
      onClose={onClose}
      title={t("ccPaymentProof")}
      subtitle={t("ccPaymentProofHint")}
      maxWidth="4xl"
      maxHeight="calc(100vh - 3rem)"
      zIndexClass="z-[210]"
      closeLabel={t("ccClose")}
      contentVariant="plain"
      bodyClassName="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4 sm:p-6"
    >
      {ticketId ? (
        <PaymentProofPanel key={ticketId} ticketId={ticketId} onSaved={onSaved} showHint={false} />
      ) : null}
    </CallCenterModal>
  );
};

export default PaymentProofModal;
